import { exportHack } from '../../utils/exportHack';
import { CompatibilityLayer as AutocompleteAddress, } from './CompatibilityLayer';
import GoogleMapsModule from './GoogleMapsModule';
const ExportHackAutocompleteAddress = (exportHack({
    component: AutocompleteAddress,
    constants: {
        GoogleMapsModule,
    },
}));
export { ExportHackAutocompleteAddress as AutocompleteAddress, GoogleMapsModule, };
